module.exports = __webpack_public_path__ + "static/fancy-texture-e32e3c691c69f9b84913e34e241c5cd3.png";